// 活動類別代碼 → 中文（全站統一對照）
// 系統現行僅兩類：惠蓀講座 / 其他活動
// - 惠蓀講座：舊系統數字代碼 2、建立活動表單英文代碼 huisun
// - 其餘舊代碼（演講1 / 研習營3 / 興通識online4 / 其他藝文10、及 lecture/usr/workshop/
//   exhibition/competition/other）一律歸類為「其他活動」
const CATEGORY_MAP = {
  '2': '惠蓀講座',
  huisun: '惠蓀講座',
  '1': '其他活動',
  '3': '其他活動',
  '4': '其他活動',
  '10': '其他活動',
  lecture: '其他活動',
  usr: '其他活動',
  workshop: '其他活動',
  exhibition: '其他活動',
  competition: '其他活動',
  other: '其他活動'
}

export function categoryLabel(cat, emptyText = '無') {
  if (cat === null || cat === undefined || cat === '') return emptyText
  // 未知代碼一律視為「其他活動」（現行只保留兩類）
  return CATEGORY_MAP[String(cat)] || '其他活動'
}

// 活動查詢頁篩選下拉選項（現行兩類；值即為顯示標籤，過濾時以 categoryLabel 比對）
export const CATEGORY_FILTER_OPTIONS = [
  { value: '惠蓀講座', label: '惠蓀講座' },
  { value: '其他活動', label: '其他活動' }
]
